import React, { useState, useEffect } from 'react';
import '../styles/NonTeachingStaff.css';

export default function NonTeachingStaff() {

     const [isVisible, setIsVisible] = useState(false);
        
          useEffect(() => {
            setIsVisible(true);
          }, []);

  const nonTeachingStaffData = [
    { sn: 1, name: "SH. RAJVEER SAHARAN", designation: "OFFICE INCHARGE", qualification: "M. A." },
    { sn: 2, name: "SH. SANJIV BIHANI", designation: "LDC", qualification: "B.COM" },
    { sn: 3, name: "SH. ARUN KUMAR SHARMA", designation: "LDC", qualification: "M.A." },
    { sn: 4, name: "SH. SANJEV SIHAG", designation: "LDC", qualification: "B A, M A (HISTORY) RSCIT" },
    { sn: 5, name: "SMT. KIRTI YADAV", designation: "RECEPTIONIST", qualification: "M A (HISTORY)" },
    { sn: 6, name: "SH. DUSHYANT KIRODIWAL", designation: "LDC", qualification: "B. TECH" },
    { sn: 7, name: "SH. SUNIL", designation: "LDC", qualification: "B. COM" },
    { sn: 8, name: "SH. METHUR MEHTA", designation: "PEON", qualification: "7TH" },
    { sn: 9, name: "SH. VIJAY MISHRA", designation: "ELECTRICIAN", qualification: "XI" },
    { sn: 10, name: "SH. DUSHYANT KUMAR", designation: "PEON", qualification: "12TH" },
    { sn: 11, name: "SH. HANUMAN KUMAR", designation: "PEON", qualification: "8TH" },
    { sn: 12, name: "SMT.ASHA", designation: "SWEEPER", qualification: "LITERATE" },
    { sn: 13, name: "SH. GURCHARAN", designation: "PEON", qualification: "M A" },
    { sn: 14, name: "SH. BAJRANG", designation: "SWEEPER", qualification: "LITERATE" },
    { sn: 15, name: "SH. VIRENDER KUMAR", designation: "PEON", qualification: "10TH" },
    { sn: 16, name: "SH. KAILASH CHANDER", designation: "PEON", qualification: "8TH" },
    { sn: 17, name: "SMT.RAJENDER KAUR", designation: "AAYA", qualification: "12TH, NTT PASS + COM RST" },
    { sn: 18, name: "SH. KRISHAN DHALIA", designation: "PEON", qualification: "12TH" },
    { sn: 19, name: "SH. KANTA TIWARI", designation: "NIGHT WATCHMAN", qualification: "LITERATE" },
    { sn: 20, name: "SH. JAGDISH", designation: "GARDENER", qualification: "LITERATE" },
    { sn: 21, name: "SMT. MONIKA", designation: "PEON", qualification: "5TH" },
    { sn: 22, name: "SH. SURJEET", designation: "SWEEPER", qualification: "LITERATE" },
    { sn: 23, name: "SH. BANTY", designation: "PEON", qualification: "MA" }
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStaff, setFilteredStaff] = useState(nonTeachingStaffData);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setCurrentPage(1);
    
    const filtered = nonTeachingStaffData.filter(staff =>
      staff.name.toLowerCase().includes(term) ||
      staff.designation.toLowerCase().includes(term)
    );
    setFilteredStaff(filtered);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedStaff = filteredStaff.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);

  return (

     <>
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Non-Teaching-Staff</h1>
          </div>
        </div>
      </section>
    <div className="non-teaching-container">
      <div className="non-teaching-search-box">
        <input
          type="text"
          placeholder="Search by name or designation..."
          value={searchTerm}
          onChange={handleSearch}
          className="non-teaching-search-field"
        />
        <svg className="non-teaching-search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      <div className="non-teaching-entries-info">
        <div className="non-teaching-show-entries">
          Show: 
          <select 
            value={itemsPerPage} 
            onChange={(e) => {
              setItemsPerPage(e.target.value === 'all' ? filteredStaff.length : parseInt(e.target.value));
              setCurrentPage(1);
            }}
            className="non-teaching-entries-select"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="all">All</option>
          </select>
          <span className="non-teaching-entries-text"> entries</span>
        </div>
        <div className="non-teaching-showing-info">
          Showing {startIndex + 1} to {Math.min(endIndex, filteredStaff.length)} of {filteredStaff.length} entries
        </div>
      </div>

      <div className="non-teaching-table-container">
        {filteredStaff.length > 0 ? (
          <table className="non-teaching-table">
            <thead>
              <tr>
                <th>S. NO.</th>
                <th>NAME OF EMPLOYEE</th>
                <th>DESIGNATION</th>
                <th>QUALIFICATIONS</th>
              </tr>
            </thead>
            <tbody>
              {paginatedStaff.map((staff, index) => (
                <tr key={index}>
                  <td className="non-teaching-sn">{staff.sn}</td>
                  <td className="non-teaching-name">{staff.name}</td>
                  <td className="non-teaching-designation">
                    <span className="non-teaching-badge">{staff.designation}</span>
                  </td>
                  <td className="non-teaching-qualification">{staff.qualification}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="non-teaching-no-results">
            <p>No results found</p>
          </div>
        )}
      </div>

      <div className="non-teaching-pagination">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            className={`non-teaching-page-btn ${currentPage === page ? 'active' : ''}`}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </button>
        ))}
      </div>
    </div>
    </>
  );
}